/**
 * WebrtcInitializer
 *
 * Invokes useSipRegistration so SIP.js UA + registration runs when the user
 * is authenticated and WebRTC config is present. Mounts SipRemoteAudio for
 * remote call audio and output device routing.
 */

import { useSipRegistration, useSipRingtone } from '../application';

import { SipRemoteAudio } from './SipRemoteAudio';

export function WebrtcInitializer() {
  useSipRegistration();
  useSipRingtone();
  return <SipRemoteAudio />;
}
